import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
    StyledCard,
    StyledCardContent,
    Text,
    ContainedButton,
    OutlinedButton,
} from '../../index.js';

import { StyledDialog, StyledConfirmAccountPaper } from './style';

export const ConfirmAccountDialog = ({ open, onClose, deleting, onConfirm }) => {
    return (
        <StyledDialog
            scroll="body"
            open={open}
            onClose={onClose}
            aria-labelledby="ConfirmCreateAccount"
            aria-describedby="Confirm create account dialog"
            PaperComponent={StyledConfirmAccountPaper}
        >
            <StyledCard>
                <StyledCardContent
                    style={{ display: 'flex', flexDirection: 'column', rowGap: '15px' }}
                >
                    <Text $bold>{deleting ? 'Delete this account ?' : 'Create new account ?'}</Text>
                    <div style={{ minHeight: '120px' }}>
                        <Text $fontSize="14px" $color="gray2">
                            {deleting
                                ? 'After delete this account, client profile medical record'
                                : 'Once the user information has been created. the system will send an SMS to user for verify their account.'}
                        </Text>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            columnGap: '10px',
                        }}
                    >
                        {deleting ? (
                            <Fragment>
                                <ContainedButton
                                    $height="32px"
                                    $width="100px"
                                    onClick={onConfirm}
                                    $noShadow
                                    $backgroundColor="pink"
                                >
                                    Skip
                                </ContainedButton>
                                <OutlinedButton
                                    $height="32px"
                                    $width="100px"
                                    onClick={onClose}
                                    $noShadow
                                >
                                    Cancel
                                </OutlinedButton>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <OutlinedButton
                                    $height="32px"
                                    $width="100px"
                                    onClick={onClose}
                                    $color="pink"
                                    $noShadow
                                >
                                    Cancel
                                </OutlinedButton>
                                <ContainedButton
                                    $height="32px"
                                    $width="125px"
                                    onClick={onConfirm}
                                    $noShadow
                                >
                                    Send SMS
                                </ContainedButton>
                            </Fragment>
                        )}
                    </div>
                </StyledCardContent>
            </StyledCard>
        </StyledDialog>
    );
};

ConfirmAccountDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    deleting: PropTypes.bool,
    onConfirm: PropTypes.func,
};
